<template>
  <div class="friendship-level-root" :style="`paddingTop:${barHeight}px`">
    <!-- 标题栏 -->
    <van-nav-bar class="van-bar" title="" left-arrow @click-left="closeWeb">
      <template #left>
        <img class="left-nav" src="@/assets/packageAssets/common/arrow05.png" alt="" @click-left="closeWeb" />
        <span class="tit-left">
          {{ $t('lang.intimate.pageTitNew') }}
        </span>
      </template>
      <template #right>
        <div class="more-btn arLeftP16" @click="handleMore">
          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/more.png" alt="" />
          <transition name="fade">
            <div class="more-list arMoreList" v-if="showMore">
              <div class="span1" @click="aboutBond">{{ $t('lang.intimate.aboutBondNew') }}</div>
              <div class="line"></div>
              <div class="span2" @click="removeBond" v-if="data.fromGender == 1">{{ $t('lang.intimate.removeBondNew') }}</div>
            </div>
          </transition>
        </div>
      </template>
    </van-nav-bar>

    <!-- 亲密度 -->
    <div class="avatar">
      <img v-show="data.fromAvatar" :src="data.fromAvatar | imgPath" alt="avatar" />
      <div class="level-love">
        <!-- 级别 -->
        <p v-if="data.fromAvatar" class="level-num">{{ $t('lang.Lv') }}.{{ data.grade }}</p>
        <!-- 亲密值 -->
        <p class="intimate-value">
          <span>{{ data.togetherDays }}&nbsp;</span>
          <i>{{ data.togetherDays == 1 ? $t('lang.sevenKeepSignin.day') : $t('lang.intimate.days') }}</i>
        </p>
      </div>
      <img v-show="data.fromAvatar" :src="data.targetAvatar | imgPath" alt="avatar" />
    </div>

    <!-- 进度条 -->
    <div class="progress">
      <div class="progress-item">
        <van-progress class="progress-bar" color="#A338FC" track-color="#ffe9fc" :show-pivot="false" :percentage="percentageVal" stroke-width="11" />
        <span class="progress-text" v-if="data.grade == data.nextGrade">{{ $t('lang.intimate.max') }}</span>
        <span class="progress-text" v-else>{{ data.score }}/{{ data.nextGradeMinScore }}</span>
      </div>
    </div>

    <!-- 等级条 -->
    <div class="level">
      <div class="level-item currentLevel">
        <span>{{ $t('lang.Lv') }}.{{ data.grade }}</span>
      </div>
      <div class="level-tip" @click="handleToRule">
        <span v-if="data.grade == data.nextGrade">{{ $t('lang.intimate.maxLevel') }}</span>
        <span class="level-tip-text" v-else>
          {{ data.nextGradeMinScore - data.score }}&nbsp; {{ data.nextGradeMinScore - data.score == 1 ? $t('lang.intimate.point') : $t('lang.intimate.points') }}
          {{ $t('lang.host.toLevelUp') }}
        </span>
        <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/rules.png" alt="rules" />
      </div>
      <div class="level-item">
        <template>
          <span>{{ $t('lang.Lv') }}.{{ data.nextGrade }}</span>
        </template>
      </div>
    </div>

    <div class="content">
      <!-- 内容卡 -->
      <div class="days">
        <div class="days-text">
          <div class="days-data">
            <span>{{ $t('lang.intimate.message') }}</span>
            <i>{{ data.chatMsgCount }}</i>
          </div>
          <div class="days-data">
            <span>{{ $t('lang.mybean.gifts') }}</span>
            <i>{{ data.presentGiftCount }}</i>
          </div>
          <div class="days-data">
            <span>{{ $t('lang.intimate.video') }}</span>
            <i>{{ time }}</i>
          </div>
        </div>
        <div class="last-chat-time arRightTextLastTime">
          <!-- 用这个方法 handleMoment -->
          {{ $t('lang.intimate.lastContactOn') }} {{ handleMoment(data.lastConnectTime, 'DD/MM/YYYY') }}
        </div>
      </div>

      <!-- 关系轴 -->
      <div class="reward-list">
        <div class="title">
          <img class="arArrow" style="margin-right: -1px" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/day_left.png" alt="" />
          <div class="tit">{{ data.fromGender == 1 ? $t('lang.intimate.privilegesRewards') : $t('lang.intimate.reward') }}</div>
          <img class="arArrow" style="margin-left: -1px" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/day_right.png" alt="" />
        </div>

        <!-- 步骤图-版本1 -->
        <div v-if="data && !data.ifNewRuleFriend" class="steps-box step-v1">
          <!-- 目前数据长度为6 因为等级最大只有6级 -->
          <van-steps direction="vertical" :active="data.grade - 1">
            <van-step v-for="item in rewardList" :key="item.grade">
              <div class="reward-item-list">
                <!-- 等级 -->
                <div class="reward-level">{{ $t('lang.Lv') }}.{{ item.grade }}</div>
                <!-- 左边的宝箱 -->
                <div class="treasure-root" v-if="item.ifRewardProp">
                  <div class="privilege-wrapper">
                    <div class="privilege-item">
                      <div class="image-wrapper">
                        <!-- 打开的 -->
                        <template v-if="item.ifTakeReward">
                          <img
                            src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/chest_unlocked.png"
                            alt=""
                            width="40"
                            height="40"
                            @click="rewardProp(item.props, item.grade)"
                          />
                          <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png" alt="" />
                        </template>
                        <!-- 没有打开的 -->
                        <template v-else>
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/chest_locked.png" alt="" width="40" height="40" />
                          <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/lock_icon.png" alt="" />
                        </template>
                      </div>
                      <div class="title1">
                        <span :class="{ noRewardText: item.grade > data.grade }">{{ $t('lang.intimate.chest') }}({{ $t('lang.Lv') }}.{{ item.grade }})</span>
                      </div>
                      <div class="title2">
                        {{ item.ifTakeReward ? $t('lang.intimate.unlockedAtLevel') : $t('lang.intimate.unlockAtLevel') + ' ' + item.grade }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 右边的特权 -->
                <div class="privilege-root" v-if="item.ifRewardPrivilege">
                  <!-- 男性 fromGender = 1 -->
                  <template v-if="data.fromGender == 1">
                    <!-- 一级 -->
                    <template v-if="item.grade == 1">
                      <!-- 免费聊天特权 -->
                      <div class="privilege-wrapper">
                        <div class="privilege-item">
                          <div class="image-wrapper">
                            <template v-if="item.grade <= data.grade">
                              <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_messages.png" alt="" width="40" height="40" />
                              <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png" alt="" />
                            </template>
                            <template v-else>
                              <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_un_messages.png" alt="" width="40" height="40" />
                              <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/lock_icon.png" alt="" />
                            </template>
                          </div>
                          <div class="title">
                            <span :class="{ noRewardText: item.grade > data.grade }">{{ $t('lang.intimate.messagesFree') }}</span>
                          </div>
                        </div>
                      </div>
                      <!-- 发送图片特权 -->
                      <div class="privilege-wrapper">
                        <div class="privilege-item">
                          <div class="image-wrapper">
                            <template v-if="item.grade <= data.grade">
                              <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_send.png" alt="" width="40" height="40" />
                              <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png" alt="" />
                            </template>
                            <template v-else>
                              <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_un_send.png" alt="" width="40" height="40" />
                              <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/lock_icon.png" alt="" />
                            </template>
                          </div>
                          <div class="title">
                            <span :class="{ noRewardText: item.grade > data.grade }">{{ $t('lang.intimate.sendPhotos') }}</span>
                          </div>
                        </div>
                      </div>
                    </template>
                    <!-- 三级 -->
                    <template v-if="item.grade == 3">
                      <!-- 私密视频特权 -->
                      <div class="privilege-wrapper">
                        <div class="privilege-item">
                          <div class="image-wrapper">
                            <template v-if="item.grade <= data.grade">
                              <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_private.png" alt="" width="40" height="40" />
                              <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png" alt="" />
                            </template>
                            <template v-else>
                              <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_un_private.png" alt="" width="40" height="40" />
                              <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/lock_icon.png" alt="" />
                            </template>
                          </div>
                          <div class="title">
                            <span :class="{ noRewardText: item.grade > data.grade }">{{ $t('lang.intimate.unlockVideos') }}</span>
                          </div>
                        </div>
                      </div>
                    </template>
                  </template>

                  <!-- 女性 fromGender = 2 -->
                  <template v-else>
                    <!-- 等级start -->
                    <!-- 一级 -->
                    <template v-if="item.grade == 1">
                      <!-- 发送图片特权 -->
                      <div class="privilege-wrapper">
                        <div class="privilege-item">
                          <div class="image-wrapper">
                            <template v-if="item.grade <= data.grade">
                              <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_send.png" alt="" width="40" height="40" />
                              <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png" alt="" />
                            </template>
                            <template v-else>
                              <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_un_send.png" alt="" width="40" height="40" />
                              <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/lock_icon.png" alt="" />
                            </template>
                          </div>
                          <div class="title">
                            <span :class="{ noRewardText: item.grade > data.grade }">{{ $t('lang.intimate.sendPhotos') }}</span>
                          </div>
                        </div>
                      </div>
                      <!-- 2 beans特权 -->
                      <div class="privilege-wrapper" v-if="item.rewardBeanNumber">
                        <div class="privilege-item">
                          <div class="image-wrapper">
                            <template v-if="item.grade <= data.grade">
                              <img :src="getMatchImg('beans')" alt="" width="40" height="40" />
                              <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png" alt="" />
                            </template>
                            <template v-else>
                              <img :src="getMatchImg('beans-off')" alt="" width="40" height="40" />
                              <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/lock_icon.png" alt="" />
                            </template>
                          </div>
                          <div class="title">
                            <span :class="{ noRewardText: item.grade > data.grade }">2&nbsp;{{ $t('lang.mybean.beans') }}</span>
                          </div>
                        </div>
                      </div>
                    </template>
                    <!-- 二级 -->
                    <template v-if="item.grade == 2 && item.rewardBeanNumber">
                      <!-- 20 beans特权 -->
                      <div class="privilege-wrapper">
                        <div class="privilege-item">
                          <div class="image-wrapper">
                            <template v-if="item.grade <= data.grade">
                              <img :src="getMatchImg('beans')" alt="" width="40" height="40" />
                              <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png" alt="" />
                            </template>
                            <template v-else>
                              <img :src="getMatchImg('beans-off')" alt="" width="40" height="40" />
                              <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/lock_icon.png" alt="" />
                            </template>
                          </div>
                          <div class="title">
                            <span :class="{ noRewardText: item.grade > data.grade }">{{ item.rewardBeanNumber }}&nbsp;{{ $t('lang.mybean.beans') }}</span>
                          </div>
                        </div>
                      </div>
                    </template>
                    <!-- 三级 -->
                    <template v-if="item.grade == 3 && item.rewardBeanNumber">
                      <!-- 50 beans特权 -->
                      <div class="privilege-wrapper">
                        <div class="privilege-item">
                          <div class="image-wrapper">
                            <template v-if="item.grade <= data.grade">
                              <img :src="getMatchImg('beans')" alt="" width="40" height="40" />
                              <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png" alt="" />
                            </template>
                            <template v-else>
                              <img :src="getMatchImg('beans-off')" alt="" width="40" height="40" />
                              <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/lock_icon.png" alt="" />
                            </template>
                          </div>
                          <div class="title">
                            <span :class="{ noRewardText: item.grade > data.grade }">{{ item.rewardBeanNumber }}&nbsp;{{ $t('lang.mybean.beans') }}</span>
                          </div>
                        </div>
                      </div>
                    </template>
                    <!-- 四级 -->
                    <template v-if="item.grade == 4 && item.rewardBeanNumber">
                      <!-- 100 beans特权 -->
                      <div class="privilege-wrapper">
                        <div class="privilege-item">
                          <div class="image-wrapper">
                            <template v-if="item.grade <= data.grade">
                              <img :src="getMatchImg('beans')" alt="" width="40" height="40" />
                              <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png" alt="" />
                            </template>
                            <template v-else>
                              <img :src="getMatchImg('beans-off')" alt="" width="40" height="40" />
                              <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/lock_icon.png" alt="" />
                            </template>
                          </div>
                          <div class="title">
                            <span :class="{ noRewardText: item.grade > data.grade }">{{ item.rewardBeanNumber }}&nbsp;{{ $t('lang.mybean.beans') }}</span>
                          </div>
                        </div>
                      </div>
                    </template>
                    <!-- 五级 -->
                    <template v-if="item.grade == 5 && item.rewardBeanNumber">
                      <!-- - 200 beans特权 -->
                      <div class="privilege-wrapper">
                        <div class="privilege-item">
                          <div class="image-wrapper">
                            <template v-if="item.grade <= data.grade">
                              <img :src="getMatchImg('beans')" alt="" width="40" height="40" />
                              <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png" alt="" />
                            </template>
                            <template v-else>
                              <img :src="getMatchImg('beans-off')" alt="" width="40" height="40" />
                              <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/lock_icon.png" alt="" />
                            </template>
                          </div>
                          <div class="title">
                            <span :class="{ noRewardText: item.grade > data.grade }">{{ item.rewardBeanNumber }}&nbsp;{{ $t('lang.mybean.beans') }}</span>
                          </div>
                        </div>
                      </div>
                    </template>
                    <!-- 六级 -->
                    <template v-if="item.grade == 6 && item.rewardBeanNumber">
                      <!-- 500 beans特权 -->
                      <div class="privilege-wrapper">
                        <div class="privilege-item">
                          <div class="image-wrapper">
                            <template v-if="item.grade <= data.grade">
                              <img :src="getMatchImg('beans')" alt="" width="40" height="40" />
                              <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png" alt="" />
                            </template>
                            <template v-else>
                              <img :src="getMatchImg('beans-off')" alt="" width="40" height="40" />
                              <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/lock_icon.png" alt="" />
                            </template>
                          </div>
                          <div class="title">
                            <span :class="{ noRewardText: item.grade > data.grade }">{{ item.rewardBeanNumber }}&nbsp;{{ $t('lang.mybean.beans') }}</span>
                          </div>
                        </div>
                      </div>
                    </template>
                    <!-- 等级end -->
                  </template>
                </div>
              </div>
            </van-step>
          </van-steps>
        </div>

        <!-- 步骤图-版本2 -->
        <div v-else class="steps-box step-v2">
          <template v-if="data.fromGender == 1">
            <div class="reward-item-list" v-for="item in rewardListNew" :key="item.grade">
              <div class="reward-level">{{ $t('lang.Lv') }}.{{ item.grade }}</div>
              <div class="privilege-root">
                <!-- 一级 -->
                <template v-if="item.grade == 1">
                  <!-- 发送图片特权 -->
                  <div class="privilege-wrapper" id="male-grade1-type0">
                    <div class="privilege-item" @click="handleGet(item, 0)">
                      <div class="image-wrapper">
                        <template v-if="item.grade <= data.grade">
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_send.png" alt="" width="40" height="40" />
                          <img v-if="item.children[0].ifTakeReward" class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png" alt="" />
                        </template>
                        <template v-else>
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_un_send.png" alt="" width="40" height="40" />
                        </template>
                      </div>
                      <div class="title">
                        <span :class="{ noRewardText: item.grade > data.grade }">{{ $t('lang.intimate.sendPhotos') }}</span>
                      </div>
                    </div>
                  </div>
                  <!-- 免费聊天特权 -->
                  <div class="privilege-wrapper" id="male-grade1-type1">
                    <div class="privilege-item" @click="handleGet(item, 1)">
                      <div class="image-wrapper">
                        <template v-if="item.grade <= data.grade">
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_messages.png" alt="" width="40" height="40" />
                          <img v-if="item.children[1].ifTakeReward" class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png" alt="" />
                        </template>
                        <template v-else>
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_un_messages.png" alt="" width="40" height="40" />
                        </template>
                      </div>
                      <div class="title">
                        <span :class="{ noRewardText: item.grade > data.grade }">{{ $t('lang.commonM.k151') }}</span>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-if="item.grade == 2">
                  <!-- 优惠券 -->
                  <div class="privilege-wrapper" id="male-grade2-type0">
                    <div class="privilege-item" @click="handleGet(item, 0)">
                      <div class="image-wrapper">
                        <template v-if="item.grade <= data.grade">
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_coupon.png" alt="" width="40" height="40" />
                          <img v-if="item.children[0].ifTakeReward" class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png" alt="" />
                        </template>
                        <template v-else>
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_un_coupon.png" alt="" width="40" height="40" />
                        </template>
                      </div>
                      <div class="title">
                        <span :class="{ noRewardText: item.grade > data.grade }">{{ $t('lang.giftSign.coupon') }} x1</span>
                      </div>
                    </div>
                  </div>
                  <!-- chocolate 替换了原来得 gem -->
                  <div class="privilege-wrapper" id="male-grade2-type1">
                    <div class="privilege-item" @click="handleGet(item, 1, 'gem')">
                      <div class="image-wrapper">
                        <template v-if="item.grade <= data.grade">
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_chocolate.png" alt="" width="40" height="40" />
                          <img v-if="item.children[1].ifTakeReward" class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png" alt="" />
                        </template>
                        <template v-else>
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_un_chocolate.png" alt="" width="40" height="40" />
                        </template>
                      </div>
                      <div class="title" v-if="item.children[1]">
                        <span :class="{ noRewardText: item.grade > data.grade }">{{ item.children[1].propName }} x1</span>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- 三级 -->
                <template v-else-if="item.grade == 3">
                  <!-- 优惠券 -->
                  <div class="privilege-wrapper" id="male-grade3-type0">
                    <div class="privilege-item" @click="handleGet(item, 0)">
                      <div class="image-wrapper">
                        <template v-if="item.grade <= data.grade">
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_coupon.png" alt="" width="40" height="40" />
                          <img v-if="item.children[0].ifTakeReward" class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png" alt="" />
                        </template>
                        <template v-else>
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_un_coupon.png" alt="" width="40" height="40" />
                        </template>
                      </div>
                      <div class="title">
                        <span :class="{ noRewardText: item.grade > data.grade }">{{ $t('lang.giftSign.coupon') }} x1</span>
                      </div>
                    </div>
                  </div>
                  <!-- 私密视频特权 -->
                  <div class="privilege-wrapper" id="male-grade3-type1">
                    <div class="privilege-item" @click="handleGet(item, 1)">
                      <div class="image-wrapper">
                        <template v-if="item.grade <= data.grade">
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_private.png" alt="" width="40" height="40" />
                          <img v-if="item.children[1].ifTakeReward" class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png" alt="" />
                        </template>
                        <template v-else>
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_un_private.png" alt="" width="40" height="40" />
                        </template>
                      </div>
                      <div class="title">
                        <span :class="{ noRewardText: item.grade > data.grade }">{{ $t('lang.intimate.unlockVideos') }}</span>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- 四级 -->
                <template v-else-if="item.grade == 4">
                  <!-- 优惠券 -->
                  <div class="privilege-wrapper" id="male-grade4-type0">
                    <div class="privilege-item" @click="handleGet(item, 0)">
                      <div class="image-wrapper">
                        <template v-if="item.grade <= data.grade">
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_coupon.png" alt="" width="40" height="40" />
                          <img v-if="item.children[0].ifTakeReward" class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png" alt="" />
                        </template>
                        <template v-else>
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_un_coupon.png" alt="" width="40" height="40" />
                        </template>
                      </div>
                      <div class="title">
                        <span :class="{ noRewardText: item.grade > data.grade }">{{ $t('lang.giftSign.coupon') }} x1</span>
                      </div>
                    </div>
                  </div>
                  <!-- bunnyposy 替换了 rose -->
                  <div class="privilege-wrapper" id="male-grade4-type1">
                    <div class="privilege-item" @click="handleGet(item, 1, 'rose')">
                      <div class="image-wrapper">
                        <template v-if="item.grade <= data.grade">
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_bunnyposy.png" alt="" width="40" height="40" />
                          <img v-if="item.children[1].ifTakeReward" class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png" alt="" />
                        </template>
                        <template v-else>
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_un_bunnyposy.png" alt="" width="40" height="40" />
                        </template>
                      </div>
                      <div class="title" v-if="item.children[1]">
                        <span :class="{ noRewardText: item.grade > data.grade }">{{ item.children[1].propName }} x1</span>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- 五级 -->
                <template v-else-if="item.grade == 5">
                  <!-- 优惠券 -->
                  <div class="privilege-wrapper" id="male-grade5-type0">
                    <div class="privilege-item" @click="handleGet(item, 0)">
                      <div class="image-wrapper">
                        <template v-if="item.grade <= data.grade">
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_coupon.png" alt="" width="40" height="40" />
                          <img v-if="item.children[0].ifTakeReward" class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png" alt="" />
                        </template>
                        <template v-else>
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_un_coupon.png" alt="" width="40" height="40" />
                        </template>
                      </div>
                      <div class="title">
                        <span :class="{ noRewardText: item.grade > data.grade }">{{ $t('lang.giftSign.coupon') }} x1</span>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- 六级 -->
                <template v-else-if="item.grade == 6">
                  <div class="privilege-wrapper" id="male-grade6-type0">
                    <div class="privilege-item" @click="handleGet(item, 0)">
                      <div class="image-wrapper">
                        <template v-if="item.grade <= data.grade">
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_coupon.png" alt="" width="40" height="40" />
                          <img v-if="item.children[0].ifTakeReward" class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png" alt="" />
                        </template>
                        <template v-else>
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_un_coupon.png" alt="" width="40" height="40" />
                        </template>
                      </div>
                      <div class="title">
                        <span :class="{ noRewardText: item.grade > data.grade }">{{ $t('lang.giftSign.coupon') }} x1</span>
                      </div>
                    </div>
                  </div>
                  <!-- purse 替换了 dream box -->
                  <div class="privilege-wrapper" id="male-grade6-type1">
                    <div class="privilege-item" @click="handleGet(item, 1, 'dream')">
                      <div class="image-wrapper">
                        <template v-if="item.grade <= data.grade">
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_purse.png" alt="" width="40" height="40" />
                          <img v-if="item.children[1].ifTakeReward" class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png" alt="" />
                        </template>
                        <template v-else>
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_un_purse.png" alt="" width="40" height="40" />
                        </template>
                      </div>
                      <div class="title" v-if="item.children[1]">
                        <span :class="{ noRewardText: item.grade > data.grade }">{{ item.children[1].propName }} x1</span>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </template>
          <template v-if="data.fromGender == 2">
            <div class="reward-item-list" v-for="item in rewardListNew" :key="item.grade">
              <div v-if="item.grade == 1 || item.grade == 3 || item.grade == 5" class="reward-level">{{ $t('lang.Lv') }}.{{ item.grade }}</div>
              <div class="privilege-root" v-if="[1, 3, 5].includes(item.grade)">
                <!-- 一级 -->
                <template v-if="item.grade == 1">
                  <!-- 发送图片特权 -->
                  <div class="privilege-wrapper" id="female-grade1-type0">
                    <div class="privilege-item" @click="handleGet(item, 0)">
                      <div class="image-wrapper">
                        <template v-if="item.grade <= data.grade">
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_send.png" alt="" width="40" height="40" />
                          <img v-if="item.children[0].ifTakeReward" class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png" alt="" />
                        </template>
                        <template v-else>
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_un_send.png" alt="" width="40" height="40" />
                        </template>
                      </div>
                      <div class="title">
                        <span :class="{ noRewardText: item.grade > data.grade }">{{ $t('lang.intimate.sendPhotos') }}</span>
                      </div>
                    </div>
                  </div>
                  <!-- cocktail -->
                  <div class="privilege-wrapper" id="female-grade1-type1">
                    <div class="privilege-item" @click="handleGet(item, 1, 'cocktail')">
                      <div class="image-wrapper">
                        <template v-if="item.grade <= data.grade">
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_cocktail.png" alt="" width="40" height="40" />
                          <img v-if="item.children[1].ifTakeReward" class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png" alt="" />
                        </template>
                        <template v-else>
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_un_cocktail.png" alt="" width="40" height="40" />
                        </template>
                      </div>
                      <div class="title" v-if="item.children[1]">
                        <span :class="{ noRewardText: item.grade > data.grade }">{{ item.children[1].propName }} x1</span>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- 三级 -->
                <template v-if="item.grade == 3">
                  <div class="privilege-wrapper" id="female-grade3-type0">
                    <div class="privilege-item" @click="handleGet(item, 0, 'cocktail')">
                      <div class="image-wrapper">
                        <template v-if="item.grade <= data.grade">
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_cocktail.png" alt="" width="40" height="40" />
                          <img v-if="item.children[0].ifTakeReward" class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png" alt="" />
                        </template>
                        <template v-else>
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_un_cocktail.png" alt="" width="40" height="40" />
                        </template>
                      </div>
                      <div class="title" v-if="item.children[0]">
                        <span :class="{ noRewardText: item.grade > data.grade }">{{ item.children[0].propName }} x1</span>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- 五级 -->
                <template v-if="item.grade == 5">
                  <div class="privilege-wrapper" id="female-grade5-type0">
                    <div class="privilege-item" @click="handleGet(item, 0, 'cocktail')">
                      <div class="image-wrapper">
                        <template v-if="item.grade <= data.grade">
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_cocktail.png" alt="" width="40" height="40" />
                          <img v-if="item.children[0].ifTakeReward" class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png" alt="" />
                        </template>
                        <template v-else>
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_un_cocktail.png" alt="" width="40" height="40" />
                        </template>
                      </div>
                      <div class="title" v-if="item.children[0]">
                        <span :class="{ noRewardText: item.grade > data.grade }">{{ item.children[0].propName }} x1</span>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </template>

          <div v-if="rewardListNew && rewardListNew.length" class="reward-bar"></div>
        </div>
      </div>
    </div>

    <!-- 移除关系弹窗 -->
    <ConfirmAuto :showDia="showConfirmAuto" :title="title" :content="content" :leftBtnText="leftBtnText" :rightBtnText="rightBtnText" @leftBtn="leftBtn" @rightBtn="rightBtn" />

    <!-- 打开宝箱弹窗 -->
    <van-popup class="popup-box" v-model="showProp" @close="closeProp" :lock-scroll="false">
      <div class="prop-tit">{{ $t('lang.intimate.chest') }}({{ $t('lang.Lv') }}.{{ chooseBlockGender }})</div>
      <div class="prop" :class="{ propNum: propsList.length > 3 }">
        <div class="prop-content" v-for="(item, index) in propsList" :key="index">
          <img v-if="item.propType == 1" :src="getMatchImg('chat-pass')" alt="" />
          <img v-if="item.propType == 3" :src="getMatchImg('beans')" alt="" />
          <img v-if="item.propType == 9" :src="getMatchImg('coupon')" alt="" />
          <div class="coupon-text">
            <i v-if="item.propType == 1">{{ $t('lang.giftSign.chatPass') }}</i>
            <i v-if="item.propType == 9">{{ $t('lang.giftSign.coupon') }}</i>
            x{{ item.rewardNumber }}
            <span class="tip" v-if="item.extraAmount">({{ $t('lang.coupon.extra') }} {{ item.extraAmount }})</span>
          </div>
        </div>
      </div>
      <div class="close-btn" @click="closeProp">{{ $t('lang.intimate.close') }}</div>
    </van-popup>

    <!-- New friendship 弹框 -->
    <div class="dialog-mask" v-if="showNewfriendship && !laterShowNewfriendship" @click.self="showNewfriendship = false">
      <div class="friendship-dialog">
        <div class="friendship-dia-head">
          <span>{{ $t('lang.commonM.k156') }}</span>
          <img src="./images/up-arrow.png" />
        </div>
        <div v-if="data.fromGender === 1" class="friendship-dia-bd">
          <div class="friendship-dia-con">
            <div class="friendship-dia-tit">{{ $t('lang.commonM.k157') }}</div>
            <div class="friendship-tips">{{ $t('lang.commonM.k158') }}</div>
            <div class="friendship-rewards">
              <div>
                <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_chocolate.png" alt="" />
                <span>Lv.2</span>
              </div>
              <div>
                <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_bunnyposy.png" alt="" />
                <span>Lv.4</span>
              </div>
              <div>
                <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_purse.png" alt="" />
                <span>Lv.6</span>
              </div>
            </div>
          </div>
          <div class="ok-btn" @click="handleLevelOk">{{ $t('lang.ok') }}</div>
        </div>

        <div v-if="data.fromGender === 2" class="friendship-dia-bd">
          <van-swipe class="my-swipe" :autoplay="3000">
            <van-swipe-item>
              <div class="friendship-dia-con">
                <div class="friendship-dia-tit">{{ $t('lang.commonM.k157') }}</div>
                <div class="friendship-tips">{{ $t('lang.commonM.k256') }}</div>
                <div class="friendship-rewards">
                  <div>
                    <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_cocktail.png" alt="" />
                    <span>Lv.1</span>
                  </div>
                  <div>
                    <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_cocktail.png" alt="" />
                    <span>Lv.3</span>
                  </div>
                  <div>
                    <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_cocktail.png" alt="" />
                    <span>Lv.5</span>
                  </div>
                </div>
              </div>
            </van-swipe-item>
            <van-swipe-item>
              <div class="friendship-dia-con">
                <div class="friendship-dia-tit">{{ $t('lang.commonM.k157') }}</div>
                <!-- 男用户 -->
                <div class="friendship-tips">{{ $t('lang.commonM.k257') }}</div>
                <div class="friendship-rewards">
                  <div>
                    <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_chocolate.png" alt="" />
                    <span>Lv.2</span>
                  </div>
                  <div>
                    <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_bunnyposy.png" alt="" />
                    <span>Lv.4</span>
                  </div>
                  <div>
                    <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_purse.png" alt="" />
                    <span>Lv.6</span>
                  </div>
                </div>
              </div>
            </van-swipe-item>
          </van-swipe>
          <div class="ok-btn" @click="handleLevelOk">{{ $t('lang.ok') }}</div>
        </div>
      </div>
    </div>

    <!-- Send Gift 弹框 -->
    <div class="dialog-mask" v-if="showSendGift" @click.self="showSendGift = false">
      <div class="sendgift-dialog">
        <div class="sendgift-tit">{{ $t('lang.commonM.k159') }}</div>
        <div class="sendgift-rewards">
          <img v-if="waitSendObj && waitSendObj.imgType === 'gem'" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_chocolate.png" alt="" />
          <img v-if="waitSendObj && waitSendObj.imgType === 'rose'" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_bunnyposy.png" alt="" />
          <img v-if="waitSendObj && waitSendObj.imgType === 'dream'" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_purse.png" alt="" />
          <img v-if="waitSendObj && waitSendObj.imgType === 'cocktail'" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_cocktail.png" alt="" />
        </div>
        <div class="sendgift-tips">{{ $t('lang.commonM.k160') }}</div>

        <div class="send-btn" @click="handleSend">{{ $t('lang.commonM.k161') }}</div>
        <div class="later-btn" @click="handleLater">{{ $t('lang.commonM.k162') }}</div>
      </div>
    </div>

    <div v-if="guideShow" class="new-leve-guide">
      <div class="guide-top">
        <div class="guide-btn">
          <div @click.stop="handleGuideOk">{{ $t('lang.ok') }}</div>
        </div>
        <div class="guide-tip1">{{ $t('lang.commonM.k163') }}</div>
        <div class="guide-tip2">{{ $t('lang.commonM.k164') }}</div>
        <div class="guide-mark" :style="{ left: `${targetLoc.l + targetLoc.w / 2}px` }">
          <div></div>
        </div>
      </div>
      <div class="guide-middle">
        <template v-if="$i18n.locale === 'ar'">
          <div class="guide-left" style="flex: 1"></div>
          <div class="guide-center" :style="{ width: targetLoc.w + 'px', height: targetLoc.h + 'px' }">
            <div class="guide-view"></div>
            <div class="radius-item radius-item-1">
              <div></div>
            </div>
            <div class="radius-item radius-item-2">
              <div></div>
            </div>
            <div class="radius-item radius-item-3">
              <div></div>
            </div>
            <div class="radius-item radius-item-4">
              <div></div>
            </div>
          </div>
          <div class="guide-right" :style="{ width: targetLoc.l + 'px' }" style="width: 105px"></div>
        </template>
        <template v-else>
          <div class="guide-left" :style="{ width: targetLoc.l + 'px' }" style="width: 105px"></div>
          <div class="guide-center" :style="{ width: targetLoc.w + 'px', height: targetLoc.h + 'px' }">
            <div class="guide-view"></div>
            <div class="radius-item radius-item-1">
              <div></div>
            </div>
            <div class="radius-item radius-item-2">
              <div></div>
            </div>
            <div class="radius-item radius-item-3">
              <div></div>
            </div>
            <div class="radius-item radius-item-4">
              <div></div>
            </div>
          </div>
          <div class="guide-right" style="flex: 1"></div>
        </template>
      </div>
      <div class="guide-bottom" :style="{ height: targetLoc.b + 'px' }"></div>
    </div>
  </div>
</template>

<script>
// 亲密度说明
import { apiIntimacyFriendship, apiDeleteFriendship } from '@/api/imee.js'
import { getDateDiff } from '@/utils/public.js'
import CConfirmAuto from '@/components/CConfirmAuto'
import newLevelGuide from './mixin/new-level-guide.js'

export default {
  components: {
    ConfirmAuto: CConfirmAuto
  },
  mixins: [newLevelGuide],
  props: {},
  data() {
    const query = this.$route.query
    return {
      data: {},
      rewardList: [],
      time: null,
      targetUid: query.targetUid,
      showMore: false,
      gender: null, // 1 男 2 女

      showConfirmAuto: false, // 左上角的移除关系 确认弹窗
      title: this.$t('lang.cfm.removeTitNew'),
      // content: 'Are you sure you want to remove',
      removeCon1: this.$t('lang.cfm.removeCon1'),
      removeCon2: this.$t('lang.cfm.removeCon2New'),
      leftBtnText: this.$t('lang.cfm.removeBtn'),
      rightBtnText: this.$t('lang.cfm.cancelBtn'),

      showProp: false,
      chooseBlockGender: 0,
      chooseBlockProps: [],
      propsList: [],

      rewardListNew: []
    }
  },
  created() {
    this.fatchIntimacyDiary(true)
  },
  methods: {
    // 亲密度数据
    fatchIntimacyDiary(needUnreceiveGuide) {
      // this.targetUid   对方的uid字段
      if (this.targetUid) {
        apiIntimacyFriendship(this.targetUid).then((res) => {
          if (res) {
            this.data = res
            this.time = getDateDiff(res.videoCallTimeSeconds)

            if (res.rewards) {
              this.rewardList = res.rewards || []
            }

            if (res.rewardsV2) {
              try {
                // 新好友权益数据转换
                let rewardKes = Object.keys(res.rewardsV2)
                let arr = []
                rewardKes.forEach((keyItem) => {
                  const tarObj = {
                    grade: keyItem.replace('GRADE_', ''),
                    children: res.rewardsV2[keyItem].map((ele) => {
                      return {
                        ifTakeReward: ele.ifTakeReward,
                        ...ele.propInfo
                      }
                    })
                  }
                  if (tarObj.grade) {
                    tarObj.grade = tarObj.grade * 1
                  }
                  arr.push(tarObj)
                })

                this.rewardListNew = arr

                // 未领取引导
                let hasUreceiveGift = false
                if (needUnreceiveGuide) {
                  let unReceiveObj = null
                  let typeIndex = -1
                  this.rewardListNew.forEach((item) => {
                    if (item.children && !unReceiveObj) {
                      if (item.children[0] && !item.children[0].ifTakeReward) {
                        unReceiveObj = item
                        typeIndex = 0
                        return
                      }
                      if (item.children[1] && !item.children[1].ifTakeReward) {
                        unReceiveObj = item
                        typeIndex = 1
                      }
                    }
                  })
                  const genderMap = {
                    1: 'male',
                    2: 'female'
                  }
                  hasUreceiveGift = unReceiveObj && genderMap[this.data.fromGender] && unReceiveObj.grade <= this.data.grade
                  if (hasUreceiveGift) {
                    this.$nextTick(() => {
                      const targetId = `${genderMap[this.data.fromGender]}-grade${unReceiveObj.grade}-type${typeIndex}`
                      this.locationTarget(targetId, () => {
                        this.calculatePos(targetId)
                      })
                    })
                  }
                }

                const storeMark = window.localStorage.getItem(`newFriendShowed_${this.data.fromUid}`)
                // if (this.data.ifNewRuleFriend && this.data.fromGender == 1 && storeMark !== 'showed') {
                if (this.data.ifNewRuleFriend && storeMark !== 'showed') {
                  this.showNewfriendship = true
                  window.localStorage.setItem(`newFriendShowed_${this.data.fromUid}`, 'showed')
                  if (hasUreceiveGift) {
                    this.laterShowNewfriendship = true
                  }
                }
              } catch (err) {
                this.rewardListNew = []
              }
            }

            // 埋点
            this.$client.addEvent('ep_bond_level_page', { bond_level: res.grade, from_uid: res.fromUid, to_uid: res.targetUid })
          }
        })
      }
    },
    // more 右上角
    handleMore() {
      this.showMore = !this.showMore
    },

    // 去亲密度规则页面
    handleToRule() {
      this.$router.push({
        path: '/friendship-level-rule',
        query: {
          fromPage: 'friendship-level',
          targetUid: this.targetUid
        }
      })
    },
    // 关闭消息确认弹框
    closeAutoDia() {
      this.showConfirmAuto = false
    },

    // 亲密度 移除绑定关系
    deleteBond() {
      apiDeleteFriendship(this.targetUid).then((res) => {
        if (res) {
          this.closeAutoDia()
          // 退出页面
          this.closeWeb()
          this.$client.addEvent('remove_bond', { bond_level: this.data.grade, from_uid: this.data.fromUid, to_uid: this.data.targetUid })
        }
      })
    },

    leftBtn() {
      // 移除关系
      this.deleteBond()
    },
    rightBtn() {
      // 关闭弹框
      this.closeAutoDia()
    },
    aboutBond() {
      this.handleToRule()
    },
    removeBond() {
      this.showConfirmAuto = true
    },

    // 点击打开的宝箱
    rewardProp(props, gender) {
      this.propsList = props
      this.chooseBlockGender = gender
      this.showProp = true
    },
    closeProp() {
      this.showProp = false
    }
  },
  watch: {},
  computed: {
    percentageVal() {
      if (this.data.score > this.data.nextGradeMinScore) {
        return 100
      }
      return (this.data.score / this.data.nextGradeMinScore) * 100
    },
    content() {
      return `${this.removeCon1}<i style="color:#a338fc">${this.data.targetNickname} </i>${this.removeCon2}`
    }
  }
}
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
<style lang="scss">
// ::v-deep xxx
.friendship-level-root {
  .van-swipe__indicators {
    .van-swipe__indicator {
      width: 30px;
      height: 4px;
      background: #e6e5e7 !important;
      border-radius: 2px;
    }
    .van-swipe__indicator--active {
      background: #b2b2b2 !important;
    }
  }
}
</style>
